<template>
    <div class="page">
        <div class="cont">
            <header-body advertisingPosition='3' source="kong"></header-body>
            <p class="title">共 <span>0</span> 个代理人</p>
            <div class="img">
                <img src="./img/kong.png" alt="">
                <p>您的名下暂时还没有代理人哦～</p>
            </div>
        </div>
    </div>
</template>

<script>
    import headerBody from '../../common/header/header'

    export default {
        name: "kong",
        data() {
            return {}
        },
        computed: {},
        filters: {},
        components: {
            headerBody,
        },
        created() {

        },
        methods: {}
    }
</script>

<style scoped>
    .title {
        padding: 30px 0;
        color: #999999;
    }

    .title span {
        color: #404040;
        font-size: 28px;
    }

    img {
        width: 270px;
        height: 270px;
        display: block;
        margin: auto;
        margin-bottom: 30px;
    }

    p {
        font-size: 24px;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        line-height: 34px;
    }

    .img {
        text-align: center;
        margin-top: 160px;
    }

    .page {
        background: #fff;
        position: fixed;
        height: 100vh;
        width: 100%;
        left: 0;
        top: 0;
    }
</style>
